<template>
  <div
    :class="[
      `box-insertion-teaser box-insertion-teaser--${background}`
    ]"
  >
    <box-insertion-teaser-item
      v-for="(teaserItem, index) in teaserItems"
      :key="index"
      :teaserItem="teaserItem"
    />
  </div>
</template>

<script>
  import BoxInsertionTeaserItem from '../boxInsertionTeaserItem/boxInsertionTeaserItem.vue';

  export default {
    props: ['icon1', 'icon2', 'icon3', 'headline1', 'headline2', 'headline3', 'text1', 'text2',
      'text3', 'urllink1', 'urllink2', 'urllink3', 'target1', 'target2', 'target3', 'bgcolor'],
    data() {
      return {
        background: this.bgcolor ? this.bgcolor : 'white'
      }
    },
    computed: {
      teaserItems() {
        const items = [];
        if (this.headline1 || this.text1) {
          items.push({
            'icon': this.icon1,
            'headline': this.headline1,
            'text': this.text1,
            'url': this.urllink1,
            'target': this.target1
          });
        }

        if (this.headline2 || this.text2) {
          items.push({
            'icon': this.icon2,
            'headline': this.headline2,
            'text': this.text2,
            'url': this.urllink2,
            'target': this.target2
          });
        }

        if (this.headline3 || this.text3) {
          items.push({
            'icon': this.icon3,
            'headline': this.headline3,
            'text': this.text3,
            'url': this.urllink3,
            'target': this.target3
          });
        }

        return items;
      }
    },
    components: {
      boxInsertionTeaserItem: BoxInsertionTeaserItem
    }
  };

</script>
